var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"subscription-licences"},[(_vm.meterDevice)?_c('subscription-licences-list',{attrs:{"meter-device-id":_vm.meterDevice.id,"organization-id":_vm.meterDevice.organization ? _vm.meterDevice.organization.id : null}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }